export enum NoteType {
    DIAGNOSTIC = 'DIAGNOSTIC',
    EVOLUTION = 'EVOLUTION'
}



